/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Pattern_Edited_UnnamedInputs */



/**
* | output |
* | --- |
* | "A custom pattern was edited. Its rules decide what is redacted or blocked, so this changes how requests are handled across the organisation." |
*
* @param {Audit_Details_Pattern_Edited_UnnamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_edited_unnamed = /** @type {((inputs?: Audit_Details_Pattern_Edited_UnnamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Edited_UnnamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein eigenes Muster wurde bearbeitet. Seine Regeln bestimmen, was maskiert oder blockiert wird - die Änderung wirkt sich auf alle Anfragen der Organisation aus.")
	return /** @type {LocalizedString} */ ("A custom pattern was edited. Its rules decide what is redacted or blocked, so this changes how requests are handled across the organisation.")
});